/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gd_Campus_DescInputs */

const en_gd_campus_desc = /** @type {(inputs: Gd_Campus_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Bystep class does not end with a slide deck. Students pass when their app is actually live and anyone can open it.`)
};

const id_gd_campus_desc = /** @type {(inputs: Gd_Campus_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelas Bystep tidak ditutup dengan presentasi. Peserta dinyatakan lulus saat aplikasinya benar-benar hidup dan bisa dibuka orang lain.`)
};

/**
* | output |
* | --- |
* | "A Bystep class does not end with a slide deck. Students pass when their app is actually live and anyone can open it." |
*
* @param {Gd_Campus_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const gd_campus_desc = /** @type {((inputs?: Gd_Campus_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gd_Campus_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_gd_campus_desc(inputs)
	return en_gd_campus_desc(inputs)
});